<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Delete Exam'"
    :submit-button-text="'DELETE'"
    :reset-modal="resetModal"
    :submit-modal="deleteExam"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          This action will delete the exam
          <span class="font-weight-bold">{{ examName }}</span> which is part of
          the course <span class="font-weight-bold">{{ courseId }}</span
          >. Please be REALLY FUCKING SURE you want to do this -- this action
          cannot be undone and will ruin the score reports for students who have
          already scored this exam.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        ><p class="tsny_status-text" v-if="deleteExamError">
          An error occurred deleting the practice exam
        </p></b-col
      >
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import ExamRestService from "../../services/rest/services/ExamRestService";

export default {
  name: "DeleteExamModal",
  components: { TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    examName: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteExamModal",
      deleteExamError: null
    };
  },
  methods: {
    async deleteExam(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.deleteExamError = false;

      try {
        await ExamRestService.deleteExam({
          _id: $comp.courseId,
          examName: $comp.examName
        });
        $comp.$bvModal.hide($comp.modalId);
        $comp.$emit("exam-deleted");
      } catch (err) {
        $comp.deleteExamError = true;
        console.log(err);
      }
    },
    resetModal: function() {
      this.deleteExamError = null;
    }
  }
};
</script>

<style scoped></style>
